
<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
       {{'SAVE_CONFIRMATION' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]="null"></button>
</div>
<mat-dialog-content> 
    {{'SAVE_CHANGES_MESSAGE' | translate }} {{ data.estimateName }} {{'ESTIMATE' | translate}}?
</mat-dialog-content>
<mat-dialog-actions align="end">
   <button class="openCloseBtn" mat-raised-button color="primary" [mat-dialog-close]="true">{{'YES' | translate}}</button>
   <button class="openCloseBtn" mat-raised-button color="primary" [mat-dialog-close]="false">{{'NO' | translate}}</button>
   <button class="openCloseBtn" mat-raised-button color="warn" [mat-dialog-close]="null">{{'CANCEL' | translate}}</button>
</mat-dialog-actions>